export enum PosConfigurationTypeEnum {
  discountEnabled = 'Discount Enabled',
  serviceChargeEnabled = 'Service Charge Enabled',
  quickpayEnabled = 'Quickpay Enabled',
  quickpayPaymentMethod = 'Quickpay Payment Method',
  tableServiceEnabled = 'Table Service Enabled',
  sendAndPayEnabled = 'Send + Pay Enabled',
  sendAndStayEnabled = 'Send and Stay Enabled',
  tableTagEnabled = 'Table Tag Enabled',
  productSearchEnabled = 'Product Search Enabled',
  flightSearchEnabled = 'Flight Search Enabled',
  disableCustomerReceipt = 'Disable Customer Receipt',
  serviceTypeEnabled = 'Service Type Enabled',
  loyaltyEnabled = 'Loyalty Enabled',
  flagEnabled = 'Flag Enabled',
  autoLogoutEnabled = 'Auto Logout Enabled',
  inactivityTimeoutSeconds = 'Inactivity Timeout Seconds',
  floatCollectionEnabled = 'Float Collection Enabled',
  floatCollectionValue = 'Float Collection Value',
  maximumDwellEnabled = 'Maximum Dwell Enabled',
  maximumDwellTime = 'Maximum Dwell Time',
  autoRedirectEnabled = 'Auto Redirect Enabled',
  redirectSeconds = 'Redirect Seconds',
  defaultScreen = 'Default Screen',
  productSearchOption = 'Product Search Option',
  orderConfirmationScreen = 'Order Confirmation Screen',
  bundleAutocompleteEnabled = 'Bundle Autocomplete Enabled',
  displayStockEnabled = 'Display Stock Enabled',
  displayProductImageEnabled = 'Display Product Image Enabled',
  ageVerificationEnabled = 'Age Verification Enabled',
  printLogoImageUrl = 'Print Logo Image URL',
  printBufferLogoImage = 'Print Buffer Logo Image',
  vectronIntegrationEnabled = 'Vectron Integration Enabled',
  staffEnabled = 'Staff Enabled'
}
